import { CONTRACTS, DATUM_ABI } from '../config';

export default class DatumContract {
  public readonly instance: any;
  public readonly plasmaAddress: string;

  constructor(web3: any, network: string) {
    this.plasmaAddress = CONTRACTS[network].PLASMA_ADDRESS;

    if (!this.instance) {
      const address = CONTRACTS[network].DATUM_ADDRESS;
      const Contract = web3.eth.contract(DATUM_ABI);
      this.instance = Contract.at(address);
    }
  }

  public approveTx(amount: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.instance.approve(this.plasmaAddress, amount, (err: any, res: any) => {
        if (err) {
          return reject(err);
        }
        return resolve(res);
      });
    });
  }

  public balanceOf(address: string, web3: any) {
    return new Promise<any>((resolve, reject) => {
      this.instance.balanceOf(address, (err: any, res: any) => {
        if (err) {
          return reject(err);
        }
        if (res && res.c && res.c[0]) {
          return resolve(Math.round(res.c[0] / 1e2) / 1e2);
        }
        return reject();
      });
    });
  }
}
